import React, { HTMLAttributes } from "react";
import cn from "classnames";
import Joi from "joi";
import { PurposeInput } from "../common";
import { CTA } from "./CTA";
import { useFormContext } from "../context/FormContext";
import { ErrorMessage } from "./ErrorMessage";

type IStartFormProps = HTMLAttributes<HTMLFormElement>;

const schema = Joi.object({
  mortgagePurpose: Joi.string().required().messages({
    "string.empty": "mortgage purpose"
  }),
  propertyValue: Joi.string().required().messages({
    "string.empty": "property value"
  })
});

export const StartForm: React.FC<IStartFormProps> = ({ className, ...rest }) => {
  const [errors, setErrors] = React.useState<Joi.ValidationError | null>(null);
  const { recalculateStep } = useFormContext();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const inputs = new FormData(e.currentTarget);
    const inputEntries = Object.fromEntries(inputs.entries());

    const { error } = schema.validate(inputEntries, { abortEarly: false });

    if (error) {
      setErrors(error);
    } else {
      setErrors(null);

      recalculateStep();
    }
  };

  return (
    <form {...rest} className={cn("heroff2-form", className)} onSubmit={onSubmit}>
      <h2>Join thousands of homeowners with mortgage advice you can trust.</h2>
      <PurposeInput key="startform-purposeinput" />
      <ErrorMessage errors={errors} />
      <CTA>Get started</CTA>
    </form>
  );
};
